// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md (T2)
//
// Wat de rapportagetabel toont in de kolom 'Deelnemer'. De volgorde is
// 'weet ik niet' → 'geen' → 'gevonden' → 'bestaat niet meer', zodat een
// verwijderde deelnemer nooit leest als een rapport over de hele organisatie.
// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading

/** Naam van 'geen deelnemer' — kopregel, tabel én kiezer gebruiken deze ene tekst. */
export const NO_REPORT_PERSONA_LABEL = 'Hele organisatie';

/**
 * @typedef {object} ReportPersonaLabel
 * @property {'none' | 'loading' | 'found' | 'missing'} state
 * @property {string} label - Tekst voor in de tabel
 */

/**
 * @param {import('../../types/LiveReports2').LiveReports2Doc} report
 * @param {Array<{ID: string, Name?: string}> | undefined | null} personas - `undefined`/`null` = nog niet geladen
 * @returns {ReportPersonaLabel}
 */
const describeReportPersona = (report, personas) => {
    if (!report.PersonaID) return { state: 'none', label: NO_REPORT_PERSONA_LABEL }
    if (!Array.isArray(personas)) return { state: 'loading', label: 'Deelnemer laden…' }
    const persona = personas.find((p) => p.ID === report.PersonaID)
    if (!persona) return { state: 'missing', label: 'Deelnemer bestaat niet meer' }
    return { state: 'found', label: persona.Name || 'Naamloze deelnemer' }
}

export default describeReportPersona
